import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { FACEBOOK_FORMS_LOADING, FACEBOOK_FORM_LEADS_LOADING } from "../../constants/loading.constant";
import { useGlobalCore } from "../globals";
import { facebookFormApiService } from "./services/api";
import {
  getFacebookFormFailureAction,
  getFacebookFormInitAction,
  getFacebookFormSuccessAction,
  getFacebookFormsFailureAction,
  getFacebookFormsInitAction,
  getFacebookFormsSuccessAction,
  setViewAction,
} from "./store/api-actions";
import {
  facebookFormSelector,
  facebookFormsSelector,
  facebookFormsSyncWarningSelector,
  viewSelector,
} from "./store/selector";

export function useFacebookFormCore() {
  const dispatch = useDispatch();
  const facebookForms = useSelector(facebookFormsSelector);
  const facebookFormsSyncWarning = useSelector(facebookFormsSyncWarningSelector);
  const facebookForm = useSelector(facebookFormSelector);
  const view = useSelector(viewSelector);
  const { turnOnLoading, turnOffLoading } = useGlobalCore();
  const getFacebookForms = useCallback(
    async (companyId: string) => {
      try {
        dispatch(getFacebookFormsInitAction());
        turnOnLoading(FACEBOOK_FORMS_LOADING);
        const response = await facebookFormApiService.getFacebookForms(companyId);
        dispatch(getFacebookFormsSuccessAction(response));
        turnOffLoading(FACEBOOK_FORMS_LOADING, 500);
      } catch (error: any) {
        console.error(error);
        turnOffLoading(FACEBOOK_FORMS_LOADING);
        dispatch(getFacebookFormsFailureAction({ error }));
        const status = error?.response?.status;
        if (status === 401 || status === 403) {
          toast.error(
            "Sesión inválida para este ambiente. Cierra sesión e ingresa de nuevo."
          );
        } else {
          toast.error(
            "No se pudieron cargar los formularios de Meta Ads. Revisa que Lith local esté corriendo (puerto 5004)."
          );
        }
      }
    },
    [dispatch, turnOnLoading, turnOffLoading]
  );
  const getFacebookForm = useCallback(
    async (companyId: string, formId: string) => {
      try {
        dispatch(getFacebookFormInitAction());
        turnOnLoading(FACEBOOK_FORM_LEADS_LOADING);
        const response = await facebookFormApiService.getFacebookForm(companyId, formId);
        dispatch(getFacebookFormSuccessAction(response));
        turnOffLoading(FACEBOOK_FORM_LEADS_LOADING, 500);
      } catch (error: any) {
        console.error(error);
        turnOffLoading(FACEBOOK_FORM_LEADS_LOADING);
        dispatch(getFacebookFormFailureAction({ error }));
      }
    },
    [dispatch, turnOnLoading, turnOffLoading]
  );

  return {
    facebookForms,
    facebookFormsSyncWarning,
    facebookForm,
    view,
    setView: (view: string) => dispatch(setViewAction({ view })),
    getFacebookForms,
    getFacebookForm,
  };
}
